// extracted by mini-css-extract-plugin
export default {"work-availability":"styles_work-availability__M-qqu","workAvailability":"styles_work-availability__M-qqu"};